import React from 'react';
import { NavLink } from 'react-router-dom';
import '../assets/styles/components/HomeMenu.sass';

const HomeMenu = () => (
  <div className="row home-menu">
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <ul className="home-menu__list">
            <li className="home-menu__list--item">
              <NavLink exact to="/">
                LA LEYENDA SUMMARY
              </NavLink>
            </li>
            <li className="home-menu__list--item">
              <NavLink to="/home/packages">
                PACKAGES & UPGRADES
              </NavLink>
            </li>
            <li className="home-menu__list--item">
              <NavLink to="/home/prices">
                PRICES
              </NavLink>
            </li>
            <li className="home-menu__list--item">
              <NavLink to="/home/payment">
                PAYMENT PLAN
              </NavLink>
            </li>
            <li className="home-menu__list--item">
              <NavLink to="/home/categories">
                CATEGORIES
              </NavLink>
            </li>
            <li className="home-menu__list--item">
              <NavLink to="/home/testimonials">
                TESTIMONIALS
              </NavLink>
            </li>
            <li className="home-menu__list--item">
              <NavLink to="/home/no-excuses">
                NO EXCUSES
              </NavLink>
            </li>
            <li className="home-menu__list--item">
              <NavLink to="/home/news">
                LATEST NEWS
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)

export default HomeMenu;